<form autocomplete="new-password" class="search-container" [formGroup]="form" (ngSubmit)="$event.preventDefault()">
  @if (!showFilterPanel) {
    <mat-form-field appearance="fill" class="search-input-field" [class.is-active]="showFilterPanel">
      <span matTextPrefix><mat-icon>search</mat-icon></span>
      <input
        autocomplete="new-password"
        formControlName="query"
        matInput
        [placeholder]="placeholder"
        (click)="openPanel()"
        (keydown)="onMainKeydown($event)"
      />
    </mat-form-field>
  }

  @if (showFilterPanel) {
    <div aria-hidden="true" class="search-backdrop" (click)="closePanel()"></div>
    <div
      aria-label="Search filters panel"
      class="filter-panel spri-search-panel compact"
      role="group"
      tabindex="0"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
    >
      <mat-form-field appearance="fill" class="search-input-field panel-field is-active">
        <span matTextPrefix><mat-icon>search</mat-icon></span>
        <input
          autocomplete="new-password"
          formControlName="query"
          matInput
          [placeholder]="placeholder || 'Search'"
          (keydown)="onMainKeydown($event)"
        />
        <button
          aria-label="Close search panel"
          class="close-panel-btn"
          mat-icon-button
          matSuffix
          type="button"
          (click)="closePanel()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      @if (filters && filters.length > 0) {
        <ng-template #filterChip let-filterGroup>
          <button
            class="filter-button"
            mat-button
            [class.active]="countFor(filterGroup.key) > 0"
            [class.can-clear]="countFor(filterGroup.key) > 0"
            [matMenuTriggerFor]="menuRef"
            (mouseenter)="onChipEnter(filterGroup.key)"
            (mouseleave)="onChipLeave()"
          >
            <span class="label-text">{{ chipLabel(filterGroup) }}</span>
            @if (!(countFor(filterGroup.key) > 0 && hoveredKey === filterGroup.key)) {
              <mat-icon class="icon-caret">expand_more</mat-icon>
            }
            @if (countFor(filterGroup.key) > 0 && hoveredKey === filterGroup.key) {
              <mat-icon
                aria-label="Clear {{ filterGroup.label }}"
                class="icon-clear"
                role="button"
                tabindex="0"
                (click)="clearGroup(filterGroup.key, $event)"
                (keydown.enter)="clearGroup(filterGroup.key, $event)"
                (keydown.space)="clearGroup(filterGroup.key, $event)"
                >close</mat-icon
              >
            }
          </button>

          <mat-menu #menuRef="matMenu" xPosition="after" yPosition="below">
            <div
              aria-label="Filter options menu"
              class="menu-shell"
              role="group"
              tabindex="0"
              (click)="$event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
            >
              <div class="menu-search">
                <mat-icon>search</mat-icon>
                <input
                  autocomplete="new-password"
                  name="search-{{ filterGroup.key }}"
                  type="text"
                  [ngModelOptions]="{ standalone: true }"
                  [placeholder]="'Search ' + filterGroup.label.toLowerCase()"
                  [(ngModel)]="menuSearchText[filterGroup.key]"
                />
                <button class="clear" type="button" (click)="clearMenuSearch(filterGroup.key)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <div class="menu-options">
                @for (opt of filteredOptions(filterGroup); track opt.value ?? opt.label) {
                  <div class="option">
                    <mat-checkbox
                      [checked]="isChecked(filterGroup.key, opt.value)"
                      (change)="toggleOption(filterGroup.key, opt.value)"
                    >
                      {{ opt.label }}
                    </mat-checkbox>
                  </div>
                }
                @if (!filteredOptions(filterGroup).length) {
                  <div class="empty">No matches</div>
                }
              </div>
            </div>
          </mat-menu>
        </ng-template>

        <div class="filter-row">
          @for (filterGroup of filters?.slice(0, 4) ?? []; track filterGroup?.key) {
            <ng-container [ngTemplateOutlet]="filterChip" [ngTemplateOutletContext]="{ $implicit: filterGroup }" />
          }
        </div>

        <div class="filter-row">
          @for (filterGroup of filters.slice(4); track filterGroup.key) {
            <ng-container [ngTemplateOutlet]="filterChip" [ngTemplateOutletContext]="{ $implicit: filterGroup }" />
          }
        </div>
      }

      <div class="filter-actions">
        <button
          class="search-cta"
          type="button"
          (click)="onSearch()"
          (keydown.enter)="onSearch()"
          (keydown.space)="onSearch()"
        >
          SEARCH
        </button>
        <button
          class="reset-cta"
          type="button"
          (click)="onReset()"
          (keydown.enter)="onReset()"
          (keydown.space)="onReset()"
        >
          <mat-icon class="reset-icon">autorenew</mat-icon>
          RESET
        </button>
      </div>
    </div>
  }
</form>
